/* eslint no-eval: 0 */
import React from 'react';
import gtmParts from 'react-google-tag-manager';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';

class GoogleTagManager extends React.Component {
  componentDidMount() {
    const dataLayerName = this.props.dataLayerName || 'dataLayer';
    const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

    if (!window[dataLayerName]) {
      const gtmScriptNode = document.getElementById(scriptId);
      eval(gtmScriptNode.textContent);
      const script = document.createElement('script');
      const { googleAnalyticsTrackingId, googleTagManagerId } = this.props.googleAnalyticsTrackingId;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsTrackingId}`;
      script.async = true;
      gtmScriptNode.appendChild(script);
      ReactGA.initialize(googleAnalyticsTrackingId, {
        titleCase: false,
        gaOptions: {
          allowLinker: true
        }
      });
      ReactGA.pageview(window.location.pathname);
    }
  }

  render() {
    const { dataLayerName, additionalEvents, previewVariables, googleTagManagerId } = this.props;
    const gtm = gtmParts({
      id: googleTagManagerId,
      dataLayerName,
      additionalEvents,
      previewVariables
    });

    return (
      <div>
        <div>{gtm.noScriptAsReact()}</div>
        <div id={this.props.scriptId || 'react-google-tag-manager-gtm'}>
          {gtm.scriptAsReact()}
        </div>
      </div>
    );
  }
}

GoogleTagManager.propTypes = {
  googleAnalyticsTrackingId: PropTypes.string.isRequired,
  googleTagManagerId: PropTypes.string.isRequired,
  dataLayerName: PropTypes.string,
  additionalEvents: PropTypes.object,
  previewVariables: PropTypes.bool,
  scriptId: PropTypes.string
};

GoogleTagManager.defaultProps = {
  dataLayerName: 'dataLayer',
  additionalEvents: {},
  previewVariables: false,
  scriptId: 'react-google-tag-manager-gtm'
};

export default GoogleTagManager;



// WEBPACK FOOTER //
// ./src/components/GoogleTagManager/index.jsx